// extracted by mini-css-extract-plugin
module.exports = {"brandedHeader":"brandedHeader_3rkX-","appTitle":"appTitle_2kfQP"};